<template>
  <div class="part table contracts-list animated fadeIn">
    <template v-if="loading">
      <ListSkeleton :list="9"></ListSkeleton>
    </template>
    <template v-else>
      <a-table
        v-if="isVaild"
        :columns="columns"
        :dataSource="contracts"
        :rowKey="(record, index) => record._id"
        :scroll="{ x: 900 }"
        :pagination="pagination"
        @change="change"
      >
        <span slot="signed" slot-scope="signed">
          <i class="fa fa-check" v-if="signed"> </i>
          <i class="fa fa-close" v-else> </i>
        </span>

        <span slot="deadline" slot-scope="deadline">
          {{ deadline | moment('l') }}
        </span>

        <span slot="amount" slot-scope="amount">
          <span class="badge badge-primary"> ${{ amount }}</span>
        </span>

        <span slot="note" slot-scope="note">
          <div class="sticker">
            {{ note }}
          </div>
        </span>
        <span slot="signed_date" slot-scope="signed_date">
          {{ signed_date | moment('l') }}
        </span>
        <span slot="effective_date" slot-scope="effective_date">
          {{ effective_date | moment('l') }}
        </span>

        <span slot="created_at" slot-scope="created_at">
          {{ created_at | moment('l') }}
        </span>
      </a-table>
      <div class="empty" v-else>
        <a-empty></a-empty>
      </div>
    </template>
  </div>
</template>

<script>
import ListSkeleton from '../skeleton/ListSkeleton.vue'

const KEY = 'contracts'

export default {
  components: {
    ListSkeleton,
  },
  name: 'table-contracts',
  props: ['contracts', 'pagination', 'loading'],

  data() {
    return {
      columns: [
        {
          title: '',
          key: 'no',
          width: '60px',
          align: 'center',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '',
          dataIndex: 'signed',
          key: 'signed',
          width: 40,
          scopedSlots: { customRender: 'signed' },
        },
        {
          title: 'NO.',
          dataIndex: 'contract_number',
          key: 'contract_number',
          width: '220px',
          customRender: (text, record, index) => {
            return text
          },
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          width: '100px',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
          width: '90px',
          align: 'center',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: 'Location',
          dataIndex: 'location',
          key: 'location',
          width: '160px',
          align: 'center',
          scopedSlots: { customRender: 'location' },
        },
        {
          title: 'Note',
          dataIndex: 'note',
          key: 'note',
          scopedSlots: { customRender: 'note' },
        },
        {
          title: 'Signed',
          dataIndex: 'signed_date',
          key: 'signed_date',
          width: '100px',
          scopedSlots: { customRender: 'signed_date' },
        },
        {
          title: 'Effective',
          dataIndex: 'effective_date',
          key: 'effective_date',
          width: '100px',
          scopedSlots: { customRender: 'effective_date' },
        },
        {
          title: 'Creation',
          dataIndex: 'created_at',
          key: 'created_at',
          width: '100px',
          scopedSlots: { customRender: 'created_at' },
        },
      ],
    }
  },
  methods: {
    onEdit(id) {
      router.push({ name: 'staff-detail', params: { id } })
    },
    change: (pagination, filters, sorter) => {
      store.dispatch('pm/updateQuery', { key: KEY, query: { pagination, filters, sorter } })
    },
  },
  computed: {
    isVaild() {
      return this.contracts && Array.isArray(this.contracts) && this.contracts.length > 0
    },
  },
  mounted() {
    // console.log(this.contracts)
  },
}
</script>

<style lang="scss" scoped>
.table.contracts-list {
  .tag {
    text-decoration: underline;
  }
  .sticker {
    background: #ffeb3b;
    padding: 2px 8px;
    color: #000;
    border-radius: 3px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0 0 10px #eee;
  }

  .empty {
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
